import { useEffect, useRef, useState } from 'react';
import type { PriceCleaningChoice, PrivateItemPrice } from '@/domain';

type UseCleaningChoiceProps = {
    privateItemPrice: PrivateItemPrice | undefined;
    setCleaningChoice: (choice: PriceCleaningChoice | null) => void;
};

export const useCleaningChoice = ({ privateItemPrice, setCleaningChoice }: UseCleaningChoiceProps) => {
    const [wantsCleaningService, setWantsCleaningService] = useState(false);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (privateItemPrice?.cleaning?.cleaningOption === 'OPTIONAL_GUEST_CLEANS_OR_FEE') {
            setCleaningChoice(wantsCleaningService ? 'FEE' : 'GUEST_CLEANS');
        }
    }, [wantsCleaningService, setCleaningChoice]);

    return { wantsCleaningService, setWantsCleaningService };
};
